import React from 'react';

import ListCampaignsToBeInvoiced from '../../campaigns/ListCampaignsToBeInvoiced';
import Tabs from '../../generic/Tabs';
import ListCategorizedInvoices from '../../invoices/ListCategorizedInvoices';
import { sessionShape } from '../../prop-types';
import withSessionInfo from '../../signin/with-session-info';
import { INVOICES } from '../constants';

function tabs() {
  const invoicesView = (
    <>
      <div className="mt-4" />
      <h5>Campaigns to be invoiced</h5>
      <ListCampaignsToBeInvoiced />

      <div className="mt-4" />
      <h5>All invoices</h5>
      <ListCategorizedInvoices title="" />
    </>
  );

  return [
    {
      label: 'Invoices',
      value: INVOICES,
      content: invoicesView,
    },
  ];
}

function SalesBackofficeDashboard({ session }) {
  if (!(session && session.user)) return null; // user info not yet loaded

  return (
    <Tabs
      tabs={tabs()}
      defaultActive={INVOICES}
      id="salesbackofficeDashboard"
    />
  );
}

SalesBackofficeDashboard.propTypes = {
  session: sessionShape,
};

SalesBackofficeDashboard.defaultProps = {
  session: null,
};

export default withSessionInfo(SalesBackofficeDashboard);
